module.exports = __webpack_public_path__ + "static/media/indy-thumbnail.29567aef.png";